module.exports = __webpack_public_path__ + "img/screen-users.46525b1d.svg";